/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminUserDetailsViewModel } from '../models/AdminUserDetailsViewModel';
import type { AdminUserViewModelPaginatedListViewModel } from '../models/AdminUserViewModelPaginatedListViewModel';
import type { CommandSuccessViewModel } from '../models/CommandSuccessViewModel';
import type { DeleteUserForAdminCommand } from '../models/DeleteUserForAdminCommand';
import type { ErasureDetailsViewModel } from '../models/ErasureDetailsViewModel';
import type { ErasureListItemViewModelPaginatedListViewModel } from '../models/ErasureListItemViewModelPaginatedListViewModel';
import type { ErasureSummaryViewModel } from '../models/ErasureSummaryViewModel';
import type { GetErasureForAdminQuery } from '../models/GetErasureForAdminQuery';
import type { GetErasureSummaryForAdminQuery } from '../models/GetErasureSummaryForAdminQuery';
import type { GetUserForAdminQuery } from '../models/GetUserForAdminQuery';
import type { HardDeleteUserForAdminCommand } from '../models/HardDeleteUserForAdminCommand';
import type { ListErasuresForAdminQuery } from '../models/ListErasuresForAdminQuery';
import type { ListUsersForAdminQuery } from '../models/ListUsersForAdminQuery';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UsersAdminService {
    /**
     * @param requestBody
     * @returns AdminUserViewModelPaginatedListViewModel Success
     * @throws ApiError
     */
    public static postApiUsersAdminListUsers(
        requestBody?: ListUsersForAdminQuery,
    ): CancelablePromise<AdminUserViewModelPaginatedListViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users-admin/list-users',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns AdminUserDetailsViewModel Success
     * @throws ApiError
     */
    public static postApiUsersAdminGetUser(
        requestBody?: GetUserForAdminQuery,
    ): CancelablePromise<AdminUserDetailsViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users-admin/get-user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CommandSuccessViewModel Success
     * @throws ApiError
     */
    public static postApiUsersAdminDeleteUser(
        requestBody?: DeleteUserForAdminCommand,
    ): CancelablePromise<CommandSuccessViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users-admin/delete-user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CommandSuccessViewModel Success
     * @throws ApiError
     */
    public static postApiUsersAdminHardDeleteUser(
        requestBody?: HardDeleteUserForAdminCommand,
    ): CancelablePromise<CommandSuccessViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users-admin/hard-delete-user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ErasureSummaryViewModel Success
     * @throws ApiError
     */
    public static postApiUsersAdminErasureSummary(
        requestBody?: GetErasureSummaryForAdminQuery,
    ): CancelablePromise<ErasureSummaryViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users-admin/erasure-summary',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ErasureListItemViewModelPaginatedListViewModel Success
     * @throws ApiError
     */
    public static postApiUsersAdminListErasures(
        requestBody?: ListErasuresForAdminQuery,
    ): CancelablePromise<ErasureListItemViewModelPaginatedListViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users-admin/list-erasures',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ErasureDetailsViewModel Success
     * @throws ApiError
     */
    public static postApiUsersAdminGetErasure(
        requestBody?: GetErasureForAdminQuery,
    ): CancelablePromise<ErasureDetailsViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users-admin/get-erasure',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
}
